import { ReactComponent as image } from './images/SaveEnoughToLiveOnTop.svg'
import { ThemedSVGImage } from './ThemedSVGImage'

const SaveEnoughToLiveOnThemedTopSection = () => (
  <ThemedSVGImage divProps={{ style: { height: 'auto' } }} image={image} />
)

export default SaveEnoughToLiveOnThemedTopSection
